module.exports = __webpack_public_path__ + "img/logo-18.98a357c7.png";